export default __webpack_public_path__ + "static/vimium_firefox_plugin-eb6a88e480df3aa1420bedba274d2391.png";